
export const BASE_CLASS = 'veriflyt-ticket-template-multi-select';